
export function circular(arr: number[], startIndex: number) {
  this.arr = arr;
  this.currentIndex = startIndex || 0;
}

circular.prototype.next = function() {
  const i = this.currentIndex;
  const arr = this.arr;
  this.currentIndex = i < arr.length - 1 ? i + 1 : 0;
  return this.current();
};

circular.prototype.prev = function() {
  const i = this.currentIndex;
  const arr = this.arr;
  this.currentIndex = i > 0 ? i - 1 : arr.length - 1;
  return this.current();
};

circular.prototype.current = function() {
  return this.currentIndex;
};

circular.prototype.setIndex = function(i: number) {
  const arr = this.arr;
  this.currentIndex = (i >= 0 && i <= arr.length) ? i : this.currentIndex;
  return this.currentIndex;
};
